angular.module('angus.controllers').directive('maintenanceUpdate', function() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'templates/tankMonitor/inventoryManagement/maintenanceUpdate/maintenanceUpdateView.html'
    };
});